<script>
import axios from "axios";
import {StorePath,MenuPath} from "@/path";

export default {
  props : ['selected_store','menu'],
  computed: {
    StorePath () {
        return StorePath;
    }
  },
  components : {},
  data(){
    return {
      filter : [],
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      items : [],
      form : {},
      fields : ["title","actions"],
      search : '',
      current_page : 1,
    }
  },
  mounted() {
    this.getItems();
  },
  watch : {
    search(){
      this.getItems();
    },
    current_page(){
      this.getItems();
    }
  },
  methods : {
    async toggleItem(e,v){
        try {
            let res = await axios.post(this.baseUrl + MenuPath.MENU_ITEM_STOCK_OUT,{
                item_id : v.id,
                store_id : this.selected_store.id,
                status : e
            });
            if(res.data.status){
                this.$bvToast.toast(v.title + ' of store ' + this.selected_store.name + (e ? ' Stocked In Successfully' : ' Stocked Out Successfully'),{
                    title: `Item ` + (e ? 'Stocked In' : 'Stocked Out'),
                    variant: 'success',
                    solid: true
                });
            }else{
                this.$bvToast.toast("Failed to toggle",{
                    title: `Item Toggled`,
                    variant: 'danger',
                    solid: true
                });
            }
        } catch (error) {
            console.log(error);
        }
    },
    async getItems(){
      try {
        let res = await axios.get(this.baseUrl + MenuPath.GetMenuItems,{
            params : {
              id : this.menu.id,
              store_id : this.selected_store.id,
              page : this.current_page,
              search : this.search
            }
        });
        if(res.data.status){
            this.items = res.data.data;
        }
      }catch (e){
        console.log(e);
      }
    },
  }
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <b-tabs>
        <b-tab :title="menu.menu">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive mb-0">
                <div class="pb-2 float-right w-25">
                  <b-row>
                    <b-col sm="12">
                      <b-input-group  size="sm">
                        <b-input-group-prepend is-text>
                          <i class="fa fa-search"></i>
                        </b-input-group-prepend>
                        <b-input size="sm" placeholder="Search" v-model="search"></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                    :key="items.key"
                    :items="items.data"
                    :fields="fields"
                    responsive="sm"
                    :filter="filter"
                    :current-page="current_page"
                >
                  <template v-slot:cell(actions)="row">
                    <b-checkbox switch @change="toggleItem($event,row.item)" :checked="row.item.item_locations[0]?.stock_in == true ? true : false"></b-checkbox>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination :key="items.key" v-model="current_page" :total-rows="items.total" :per-page="items.per_page"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<style>

</style>